import Types from './Types';


export const getAllTeachersRequest = (body) => ({
    type: Types.GET_TEACHERS_REQUEST,
    payload: body
});

export const getAllTeachersSuccess = (data) => ({
    type: Types.GET_TEACHERS_SUCCESS,
    payload: data
});

export const getAllTeachersFail = () => ({
    type: Types.GET_TEACHERS_FAIL
});


export const editTeacherRequest = (formData, action) => ({
    type: Types.EDIT_TEACHER_REQUEST,
    payload: formData,
    action: action
});

export const editTeacherSuccess = (data) => ({
    type: Types.EDIT_TEACHER_SUCCESS,
    payload: data
});

export const editTeacherFail = () => ({
    type: Types.EDIT_TEACHER_FAIL
});

//LOADING
export const addTeacherLoading = (isLoading) => ({
    type: Types.ADD_TEACHERS_LOADING,
    payload: isLoading
});

// Create Teacher
export const createTeacherRequest = (formData, action) => ({
    type: Types.CREATE_TEACHER_REQUEST,
    payload: formData,
    action: action
});

// Create Subject
export const createAdminSubjectRequest = (formData, action) => ({
    type: Types.CREATE_ADMIN_SUBJECT_REQUEST,
    payload: formData,
    action: action
});

export const createAdminSubjectSuccess = ({ data }) => ({
    type: Types.CREATE_ADMIN_SUBJECT_SUCCESS,
    payload: {
        data
    }
});

export const createAdminSubjectFail = () => ({
    type: Types.CREATE_ADMIN_SUBJECT_FAIL,
});

export const createTeacherSuccess = ({ data }) => ({
    type: Types.CREATE_TEACHER_SUCCESS,
    payload: {
        data
    }
});

export const createTeacherFail = () => ({
    type: Types.CREATE_TEACHER_FAIL
});

export const deleteTeacherRequest = (id) => ({
    type: Types.DELETE_TEACHER_REQUEST,
    payload: id
});

export const deleteTeacherSuccess = (id) => ({
    type: Types.DELETE_TEACHER_SUCCESS,
    payload: id
});

export const deleteTeacherFail = () => ({
    type: Types.DELETE_TEACHER_FAIL
});
